export default "__VITE_ASSET__fac43b95__"